import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertModalContent: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: Theme.px(74),
  },
  card: {
    alignItems: 'center',
    flex: 1,
  },
  dismissButtonText: {
    marginTop: Theme.px(15),
  },
  subText: {
    lineHeight: Theme.px(38),
    textAlign: 'center',
  },
  titleText: {
    lineHeight: Theme.px(48),
    paddingBottom: Theme.px(39),
    paddingTop: Theme.px(24),
    textAlign: 'center',
  },
});
